// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Orders-module__font-s-10___E51ON {
  font-size: 10px !important;
}

.Orders-module__font-s-12___d5kFV {
  font-size: 12px !important;
}

.Orders-module__font-s-13___yUoh8 {
  font-size: 13px !important;
}

.Orders-module__font-s-14___xHagY {
  font-size: 14px !important;
}

.Orders-module__font-s-15___aT6K2 {
  font-size: 15px !important;
}

.Orders-module__font-s-16___WdIll {
  font-size: 16px !important;
}

.Orders-module__font-s-18___NuG9K {
  font-size: 18px !important;
}

.Orders-module__font-s-20___NSLdg {
  font-size: 20px !important;
}

.Orders-module__font-s-22___xW2iG {
  font-size: 22px !important;
}

.Orders-module__font-s-28___Rfn7X {
  font-size: 28px !important;
}

.Orders-module__font-w-400___EgnfZ {
  font-weight: 400 !important;
}

.Orders-module__font-w-500___m_XE_ {
  font-weight: 500 !important;
}

.Orders-module__font-w-600___c8KXE {
  font-weight: 600 !important;
}

.Orders-module__font-w-700___PxjcX {
  font-weight: 700 !important;
}

.Orders-module__p-5___IKAug {
  padding: 5px !important;
}

.Orders-module__p-12___l8YyX {
  padding: 12px !important;
}

.Orders-module__p-16___ZtGEb {
  padding: 16px !important;
}

.Orders-module__p-30___fL8K7 {
  padding: 30px !important;
}

.Orders-module__p-b-0___tA_YQ {
  padding-bottom: 0 !important;
}

.Orders-module__p-b-5___Lisov {
  padding-bottom: 5px !important;
}

.Orders-module__p-b-10___SX0KJ {
  padding-bottom: 10px !important;
}

.Orders-module__p-b-12___XD5Ey {
  padding-bottom: 12px !important;
}

.Orders-module__p-b-16___cMGe8 {
  padding-bottom: 16px !important;
}

.Orders-module__p-b-18___VMkIB {
  padding-bottom: 18px !important;
}

.Orders-module__p-b-20___En1h7 {
  padding-bottom: 20px !important;
}

.Orders-module__p-b-25___XOR04 {
  padding-bottom: 25px !important;
}

.Orders-module__p-b-30___FTE0W {
  padding-bottom: 30px !important;
}

.Orders-module__p-b-50___ge1d7 {
  padding-bottom: 50px !important;
}

.Orders-module__p-t-0___nVnX_ {
  padding-top: 0 !important;
}

.Orders-module__p-t-12___v3aVm {
  padding-top: 12px !important;
}

.Orders-module__p-t-16___YhPT4 {
  padding-top: 16px !important;
}

.Orders-module__p-t-18___VFK0w {
  padding-top: 18px !important;
}

.Orders-module__p-t-20___uxwr2 {
  padding-top: 20px !important;
}

.Orders-module__p-t-30___jwAm6 {
  padding-top: 30px !important;
}

.Orders-module__p-t-40___khb6O {
  padding-top: 40px !important;
}

.Orders-module__p-t-50___wswJS {
  padding-top: 50px !important;
}

.Orders-module__p-l-20___pdxdM {
  padding-left: 20px !important;
}

.Orders-module__p-l-30___O8Mkt {
  padding-left: 30px !important;
}

.Orders-module__p-l-40___fnx_W {
  padding-left: 40px !important;
}

.Orders-module__p-r-16___f8ps_ {
  padding-right: 16px !important;
}

.Orders-module__p-r-20___mVmdL {
  padding-right: 20px !important;
}

.Orders-module__p-r-30___VlZ6p {
  padding-right: 30px !important;
}

.Orders-module__p-r-50___s9ddS {
  padding-right: 50px !important;
}

.Orders-module__p-r-60___OvXFR {
  padding-right: 60px !important;
}

.Orders-module__m-b-1___DixoA {
  margin-bottom: 1px !important;
}

.Orders-module__m-b-2___d8hms {
  margin-bottom: 2px !important;
}

.Orders-module__m-b-6___YR79X {
  margin-bottom: 6px !important;
}

.Orders-module__m-b-8___c8QAL {
  margin-bottom: 8px !important;
}

.Orders-module__m-b-10___Bb4Yv {
  margin-bottom: 10px !important;
}

.Orders-module__m-b-14___flbjf {
  margin-bottom: 14px !important;
}

.Orders-module__m-b-16___Ne59d {
  margin-bottom: 16px !important;
}

.Orders-module__m-b-20___iLu2y {
  margin-bottom: 20px !important;
}

.Orders-module__m-b-22___myaNN {
  margin-bottom: 22px !important;
}

.Orders-module__m-b-24___jnHBr {
  margin-bottom: 24px !important;
}

.Orders-module__m-b-30___hXLy9 {
  margin-bottom: 30px !important;
}

.Orders-module__m-b-32___UtX7r {
  margin-bottom: 32px !important;
}

.Orders-module__m-b-40___J1Fmc {
  margin-bottom: 40px !important;
}

.Orders-module__m-t-2___QUmAM {
  margin-top: 2px !important;
}

.Orders-module__m-t-3___YOlWo {
  margin-top: 3px !important;
}

.Orders-module__m-t-4___SCFbd {
  margin-top: 4px !important;
}

.Orders-module__m-t-5___TJYZO {
  margin-top: 5px !important;
}

.Orders-module__m-t-8___UjKEB {
  margin-top: 8px !important;
}

.Orders-module__m-t-10___bjn6j {
  margin-top: 10px !important;
}

.Orders-module__m-t-15___LVttB {
  margin-top: 15px !important;
}

.Orders-module__m-t-16___lgujG {
  margin-top: 16px !important;
}

.Orders-module__m-t-20___CoBGI {
  margin-top: 20px !important;
}

.Orders-module__m-t-22___urWtr {
  margin-top: 22px !important;
}

.Orders-module__m-t-30___Xcexg {
  margin-top: 30px !important;
}

.Orders-module__m-t-32___ieUu0 {
  margin-top: 32px !important;
}

.Orders-module__m-l-auto___rGHgZ {
  margin-left: auto !important;
}

.Orders-module__m-l-4___ds_e1 {
  margin-left: 4px !important;
}

.Orders-module__m-l-5___Bx2fv {
  margin-left: 5px !important;
}

.Orders-module__m-l-6___nRPaf {
  margin-left: 6px !important;
}

.Orders-module__m-l-8___pjFxq {
  margin-left: 8px !important;
}

.Orders-module__m-l-10___FdeMl {
  margin-left: 10px !important;
}

.Orders-module__m-l-16___RL5Xe {
  margin-left: 16px !important;
}

.Orders-module__m-l-20___fwBPt {
  margin-left: 20px !important;
}

.Orders-module__m-l-24___XaSmq {
  margin-left: 24px !important;
}

.Orders-module__m-l-30___EUkTw {
  margin-left: 30px !important;
}

.Orders-module__m-l-35___njhLp {
  margin-left: 35px !important;
}

.Orders-module__m-l-40___Jx9xL {
  margin-left: 40px !important;
}

.Orders-module__m-r-8___HJFrV {
  margin-right: 8px !important;
}

.Orders-module__m-r-10___QOnPB {
  margin-right: 10px !important;
}

.Orders-module__m-r-16___nrl0e {
  margin-right: 16px !important;
}

.Orders-module__m-r-20___k8Mfa {
  margin-right: 20px !important;
}

.Orders-module__m-r-24___tqBt2 {
  margin-right: 24px !important;
}

.Orders-module__m-r-30___v3QIv {
  margin-right: 30px !important;
}

.Orders-module__m-r-40___NDPnP {
  margin-right: 40px !important;
}

.Orders-module__border-r-3___ltqix {
  border-radius: 3px !important;
}

.Orders-module__border-r-4___X9vq3 {
  border-radius: 4px !important;
}

.Orders-module__border-r-6___LXRc3 {
  border-radius: 6px !important;
}

.Orders-module__border-r-10___bbXSR {
  border-radius: 10px !important;
}

.Orders-module__border-r-12___I9rmw {
  border-radius: 12px !important;
}

.Orders-module__border-r-16___7kL5I {
  border-radius: 16px !important;
}

.Orders-module__border-r-50___pL0B5 {
  border-radius: 50% !important;
}

.Orders-module__primary-border___mFUXx {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Orders-module__primary-border-b___mvA8c {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Orders-module__primary-border-t___CWWHZ {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Orders-module__primary-border-l___ysZ11 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Orders-module__primary-border-r___QTnDO {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Orders-module__secondary-border___qmhIs {
  border: 1px solid #637768;
}

.Orders-module__secondary-border-b___ohR9y {
  border-bottom: 1px solid #637768;
}

.Orders-module__secondary-border-t___ZkwgF {
  border-top: 1px solid #637768;
}

.Orders-module__secondary-border-l___EbjgF {
  border-left: 1px solid #637768;
}

.Orders-module__secondary-border-r___DyeXj {
  border-right: 1px solid #637768;
}

.Orders-module__gap-0___dKtCt {
  gap: 0 !important;
}

.Orders-module__gap-2___KMtKz {
  gap: 2px !important;
}

.Orders-module__gap-4___EzPfW {
  gap: 4px !important;
}

.Orders-module__gap-5___JSIRO {
  gap: 5px !important;
}

.Orders-module__gap-6___ja5UI {
  gap: 6px !important;
}

.Orders-module__gap-8___eMoSP {
  gap: 8px !important;
}

.Orders-module__gap-10___ZQxmu {
  gap: 10px !important;
}

.Orders-module__gap-12___ZrLV1 {
  gap: 12px !important;
}

.Orders-module__gap-14___af3wR {
  gap: 14px !important;
}

.Orders-module__gap-16___lMN8f {
  gap: 16px !important;
}

.Orders-module__gap-18___Y3INl {
  gap: 18px !important;
}

.Orders-module__gap-20___QMNyT {
  gap: 20px !important;
}

.Orders-module__gap-24___WmHQn {
  gap: 24px !important;
}

.Orders-module__gap-26___FavVA {
  gap: 26px !important;
}

.Orders-module__gap-30___e4bgI {
  gap: 30px !important;
}

.Orders-module__gap-32___J2C9K {
  gap: 32px !important;
}

.Orders-module__gap-40___y3TQB {
  gap: 40px !important;
}

.Orders-module__gap-50___PFxzj {
  gap: 50px !important;
}

.Orders-module__flex-1___n8lmP {
  flex: 1;
}

.Orders-module__flex-none___ItAIz {
  flex: none !important;
}

.Orders-module__flex-column___lCENZ {
  display: flex;
  flex-direction: column !important;
}

.Orders-module__flex-row___Yn1_v {
  display: flex;
  flex-direction: row !important;
}

.Orders-module__vertically-centered___y025Y {
  display: flex;
  align-items: center !important;
}

.Orders-module__horizontally-centered___b7ogc {
  display: flex;
  justify-content: center !important;
}

.Orders-module__horizontally-end___f9YET {
  display: flex;
  justify-content: end !important;
}

.Orders-module__vertically-start___Tt9g_ {
  display: flex;
  align-items: start !important;
}

.Orders-module__space-between___ZSajW {
  display: flex;
  justify-content: space-between !important;
}

.Orders-module__flex-wrap___mHl3L {
  flex-wrap: wrap !important;
}

.Orders-module__height-100___XjRGA {
  height: 100%;
}

.Orders-module__width-50___K__ba {
  width: 50% !important;
}

.Orders-module__width-100___IzYld {
  width: 100%;
}

.Orders-module__cursor-pointer___VXMwG {
  cursor: pointer;
}

.Orders-module__cursor-not-allowed___e6605 {
  cursor: not-allowed !important;
}

.Orders-module__absolute-centered___MnoIX {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Orders-module__absolute___R4Xtk {
  position: absolute;
}

.Orders-module__relative___Hnxcf {
  position: relative;
}

.Orders-module__fixed___vb9PE {
  position: fixed;
}

.Orders-module__visible___JE7rG {
  opacity: 1;
}

.Orders-module__invisible___xECoM {
  opacity: 0;
}

.Orders-module__col-90___tWxTM {
  width: 90% !important;
}

.Orders-module__col-auto___pZRAp {
  width: auto !important;
}

.Orders-module__medical-tabs___RAYVy {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Orders-module__medical-table-new___YdzWV {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Orders-module__medical-table-new___YdzWV:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Orders-module__medical-table-new___YdzWV::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Orders-module__medical-table-new___YdzWV::-webkit-scrollbar-track {
  display: none;
}
.Orders-module__medical-table-new___YdzWV.Orders-module__no-pagination___ESd5a {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Orders-module__medical-table-new___YdzWV.Orders-module__no-pagination___ESd5a:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Orders-module__medical-table-new___YdzWV.Orders-module__no-pagination___ESd5a::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Orders-module__medical-table-new___YdzWV.Orders-module__no-pagination___ESd5a::-webkit-scrollbar-track {
  display: none;
}

.Orders-module__medical-table-empty___k8Y9K {
  padding: 14px 40px !important;
}

.Orders-module__icon-btn___6oPou {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Orders-module__search-icon___uBilh {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Orders-module__disable-select___C63yL {
  user-select: none;
}

.Orders-module__break-word___tZ1sB {
  word-break: break-word;
}

.Orders-module__popup-clear-btn___Vf0Cd {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Orders-module__scroll-m-b-20___Q942S {
  scroll-margin-bottom: 20px;
}

.Orders-module__article___jXBW0 {
  height: calc(100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Orders-module__article___jXBW0:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Orders-module__article___jXBW0::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Orders-module__article___jXBW0::-webkit-scrollbar-track {
  display: none;
}
.Orders-module__article___jXBW0 .Orders-module__wrapper___wT3uL {
  margin: 27px;
}
.Orders-module__article___jXBW0 .Orders-module__width70___DEQvl {
  width: 70%;
}
.Orders-module__article___jXBW0 .Orders-module__width90___SFePn {
  width: 90%;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Orders/Orders.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;ECQE,2GDNE;ECOF,kBAAA;EACA,kBAAA;ADupBF;ACrpBE;EACE,oCAAA;EACA,mBAAA;ADupBJ;ACppBE;EACE,UAAA;EACA,6BAAA;ADspBJ;ACnpBE;EACE,aAAA;ADqpBJ;AArqBE;EACE,YAAA;AAuqBJ;AApqBE;EACE,UAAA;AAsqBJ;AAnqBE;EACE,UAAA;AAqqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.article {\n  @include verticalScroll(\n    calc(\n      100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer)\n    )\n  );\n\n  .wrapper {\n    margin: 27px;\n  }\n\n  .width70 {\n    width: 70%;\n  }\n\n  .width90 {\n    width: 90%;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Orders-module__font-s-10___E51ON`,
	"fontS12": `Orders-module__font-s-12___d5kFV`,
	"fontS13": `Orders-module__font-s-13___yUoh8`,
	"fontS14": `Orders-module__font-s-14___xHagY`,
	"fontS15": `Orders-module__font-s-15___aT6K2`,
	"fontS16": `Orders-module__font-s-16___WdIll`,
	"fontS18": `Orders-module__font-s-18___NuG9K`,
	"fontS20": `Orders-module__font-s-20___NSLdg`,
	"fontS22": `Orders-module__font-s-22___xW2iG`,
	"fontS28": `Orders-module__font-s-28___Rfn7X`,
	"fontW400": `Orders-module__font-w-400___EgnfZ`,
	"fontW500": `Orders-module__font-w-500___m_XE_`,
	"fontW600": `Orders-module__font-w-600___c8KXE`,
	"fontW700": `Orders-module__font-w-700___PxjcX`,
	"p5": `Orders-module__p-5___IKAug`,
	"p12": `Orders-module__p-12___l8YyX`,
	"p16": `Orders-module__p-16___ZtGEb`,
	"p30": `Orders-module__p-30___fL8K7`,
	"pB0": `Orders-module__p-b-0___tA_YQ`,
	"pB5": `Orders-module__p-b-5___Lisov`,
	"pB10": `Orders-module__p-b-10___SX0KJ`,
	"pB12": `Orders-module__p-b-12___XD5Ey`,
	"pB16": `Orders-module__p-b-16___cMGe8`,
	"pB18": `Orders-module__p-b-18___VMkIB`,
	"pB20": `Orders-module__p-b-20___En1h7`,
	"pB25": `Orders-module__p-b-25___XOR04`,
	"pB30": `Orders-module__p-b-30___FTE0W`,
	"pB50": `Orders-module__p-b-50___ge1d7`,
	"pT0": `Orders-module__p-t-0___nVnX_`,
	"pT12": `Orders-module__p-t-12___v3aVm`,
	"pT16": `Orders-module__p-t-16___YhPT4`,
	"pT18": `Orders-module__p-t-18___VFK0w`,
	"pT20": `Orders-module__p-t-20___uxwr2`,
	"pT30": `Orders-module__p-t-30___jwAm6`,
	"pT40": `Orders-module__p-t-40___khb6O`,
	"pT50": `Orders-module__p-t-50___wswJS`,
	"pL20": `Orders-module__p-l-20___pdxdM`,
	"pL30": `Orders-module__p-l-30___O8Mkt`,
	"pL40": `Orders-module__p-l-40___fnx_W`,
	"pR16": `Orders-module__p-r-16___f8ps_`,
	"pR20": `Orders-module__p-r-20___mVmdL`,
	"pR30": `Orders-module__p-r-30___VlZ6p`,
	"pR50": `Orders-module__p-r-50___s9ddS`,
	"pR60": `Orders-module__p-r-60___OvXFR`,
	"mB1": `Orders-module__m-b-1___DixoA`,
	"mB2": `Orders-module__m-b-2___d8hms`,
	"mB6": `Orders-module__m-b-6___YR79X`,
	"mB8": `Orders-module__m-b-8___c8QAL`,
	"mB10": `Orders-module__m-b-10___Bb4Yv`,
	"mB14": `Orders-module__m-b-14___flbjf`,
	"mB16": `Orders-module__m-b-16___Ne59d`,
	"mB20": `Orders-module__m-b-20___iLu2y`,
	"mB22": `Orders-module__m-b-22___myaNN`,
	"mB24": `Orders-module__m-b-24___jnHBr`,
	"mB30": `Orders-module__m-b-30___hXLy9`,
	"mB32": `Orders-module__m-b-32___UtX7r`,
	"mB40": `Orders-module__m-b-40___J1Fmc`,
	"mT2": `Orders-module__m-t-2___QUmAM`,
	"mT3": `Orders-module__m-t-3___YOlWo`,
	"mT4": `Orders-module__m-t-4___SCFbd`,
	"mT5": `Orders-module__m-t-5___TJYZO`,
	"mT8": `Orders-module__m-t-8___UjKEB`,
	"mT10": `Orders-module__m-t-10___bjn6j`,
	"mT15": `Orders-module__m-t-15___LVttB`,
	"mT16": `Orders-module__m-t-16___lgujG`,
	"mT20": `Orders-module__m-t-20___CoBGI`,
	"mT22": `Orders-module__m-t-22___urWtr`,
	"mT30": `Orders-module__m-t-30___Xcexg`,
	"mT32": `Orders-module__m-t-32___ieUu0`,
	"mLAuto": `Orders-module__m-l-auto___rGHgZ`,
	"mL4": `Orders-module__m-l-4___ds_e1`,
	"mL5": `Orders-module__m-l-5___Bx2fv`,
	"mL6": `Orders-module__m-l-6___nRPaf`,
	"mL8": `Orders-module__m-l-8___pjFxq`,
	"mL10": `Orders-module__m-l-10___FdeMl`,
	"mL16": `Orders-module__m-l-16___RL5Xe`,
	"mL20": `Orders-module__m-l-20___fwBPt`,
	"mL24": `Orders-module__m-l-24___XaSmq`,
	"mL30": `Orders-module__m-l-30___EUkTw`,
	"mL35": `Orders-module__m-l-35___njhLp`,
	"mL40": `Orders-module__m-l-40___Jx9xL`,
	"mR8": `Orders-module__m-r-8___HJFrV`,
	"mR10": `Orders-module__m-r-10___QOnPB`,
	"mR16": `Orders-module__m-r-16___nrl0e`,
	"mR20": `Orders-module__m-r-20___k8Mfa`,
	"mR24": `Orders-module__m-r-24___tqBt2`,
	"mR30": `Orders-module__m-r-30___v3QIv`,
	"mR40": `Orders-module__m-r-40___NDPnP`,
	"borderR3": `Orders-module__border-r-3___ltqix`,
	"borderR4": `Orders-module__border-r-4___X9vq3`,
	"borderR6": `Orders-module__border-r-6___LXRc3`,
	"borderR10": `Orders-module__border-r-10___bbXSR`,
	"borderR12": `Orders-module__border-r-12___I9rmw`,
	"borderR16": `Orders-module__border-r-16___7kL5I`,
	"borderR50": `Orders-module__border-r-50___pL0B5`,
	"primaryBorder": `Orders-module__primary-border___mFUXx`,
	"primaryBorderB": `Orders-module__primary-border-b___mvA8c`,
	"primaryBorderT": `Orders-module__primary-border-t___CWWHZ`,
	"primaryBorderL": `Orders-module__primary-border-l___ysZ11`,
	"primaryBorderR": `Orders-module__primary-border-r___QTnDO`,
	"secondaryBorder": `Orders-module__secondary-border___qmhIs`,
	"secondaryBorderB": `Orders-module__secondary-border-b___ohR9y`,
	"secondaryBorderT": `Orders-module__secondary-border-t___ZkwgF`,
	"secondaryBorderL": `Orders-module__secondary-border-l___EbjgF`,
	"secondaryBorderR": `Orders-module__secondary-border-r___DyeXj`,
	"gap0": `Orders-module__gap-0___dKtCt`,
	"gap2": `Orders-module__gap-2___KMtKz`,
	"gap4": `Orders-module__gap-4___EzPfW`,
	"gap5": `Orders-module__gap-5___JSIRO`,
	"gap6": `Orders-module__gap-6___ja5UI`,
	"gap8": `Orders-module__gap-8___eMoSP`,
	"gap10": `Orders-module__gap-10___ZQxmu`,
	"gap12": `Orders-module__gap-12___ZrLV1`,
	"gap14": `Orders-module__gap-14___af3wR`,
	"gap16": `Orders-module__gap-16___lMN8f`,
	"gap18": `Orders-module__gap-18___Y3INl`,
	"gap20": `Orders-module__gap-20___QMNyT`,
	"gap24": `Orders-module__gap-24___WmHQn`,
	"gap26": `Orders-module__gap-26___FavVA`,
	"gap30": `Orders-module__gap-30___e4bgI`,
	"gap32": `Orders-module__gap-32___J2C9K`,
	"gap40": `Orders-module__gap-40___y3TQB`,
	"gap50": `Orders-module__gap-50___PFxzj`,
	"flex1": `Orders-module__flex-1___n8lmP`,
	"flexNone": `Orders-module__flex-none___ItAIz`,
	"flexColumn": `Orders-module__flex-column___lCENZ`,
	"flexRow": `Orders-module__flex-row___Yn1_v`,
	"verticallyCentered": `Orders-module__vertically-centered___y025Y`,
	"horizontallyCentered": `Orders-module__horizontally-centered___b7ogc`,
	"horizontallyEnd": `Orders-module__horizontally-end___f9YET`,
	"verticallyStart": `Orders-module__vertically-start___Tt9g_`,
	"spaceBetween": `Orders-module__space-between___ZSajW`,
	"flexWrap": `Orders-module__flex-wrap___mHl3L`,
	"height100": `Orders-module__height-100___XjRGA`,
	"width50": `Orders-module__width-50___K__ba`,
	"width100": `Orders-module__width-100___IzYld`,
	"cursorPointer": `Orders-module__cursor-pointer___VXMwG`,
	"cursorNotAllowed": `Orders-module__cursor-not-allowed___e6605`,
	"absoluteCentered": `Orders-module__absolute-centered___MnoIX`,
	"absolute": `Orders-module__absolute___R4Xtk`,
	"relative": `Orders-module__relative___Hnxcf`,
	"fixed": `Orders-module__fixed___vb9PE`,
	"visible": `Orders-module__visible___JE7rG`,
	"invisible": `Orders-module__invisible___xECoM`,
	"col90": `Orders-module__col-90___tWxTM`,
	"colAuto": `Orders-module__col-auto___pZRAp`,
	"medicalTabs": `Orders-module__medical-tabs___RAYVy`,
	"medicalTableNew": `Orders-module__medical-table-new___YdzWV`,
	"noPagination": `Orders-module__no-pagination___ESd5a`,
	"medicalTableEmpty": `Orders-module__medical-table-empty___k8Y9K`,
	"iconBtn": `Orders-module__icon-btn___6oPou`,
	"searchIcon": `Orders-module__search-icon___uBilh`,
	"disableSelect": `Orders-module__disable-select___C63yL`,
	"breakWord": `Orders-module__break-word___tZ1sB`,
	"popupClearBtn": `Orders-module__popup-clear-btn___Vf0Cd`,
	"scrollMB20": `Orders-module__scroll-m-b-20___Q942S`,
	"article": `Orders-module__article___jXBW0`,
	"wrapper": `Orders-module__wrapper___wT3uL`,
	"width70": `Orders-module__width70___DEQvl`,
	"width90": `Orders-module__width90___SFePn`
};
module.exports = ___CSS_LOADER_EXPORT___;
